export default __webpack_public_path__ + "static/media/dit_login.a32c996d.png";